module.exports = "/cyber/_next/static/images/ball-e63b4124a3fd451ec4b3f4ce974a8a37.png";